export function getDemoFileUrl(filename = 'demo.txt') {
  const content = [
    'Green Enterprise 演示文件',
    '当前目录为独立演示前端。',
    `文件名：${filename}`,
    '内容为前端静态生成，仅用于演示。'
  ].join('\n')
  return `data:text/plain;charset=utf-8,${encodeURIComponent(content)}`
}

